import { render } from "./MainDetalProduct.vue?vue&type=template&id=42c10d11&scoped=true"
import script from "./MainDetalProduct.vue?vue&type=script&lang=js"
export * from "./MainDetalProduct.vue?vue&type=script&lang=js"

import "./MainDetalProduct.vue?vue&type=style&index=0&id=42c10d11&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c10d11"]])

export default __exports__